import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/document-services/document-services/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h2 {...{
      "id": "automated-report-generation"
    }}>{`Automated Report Generation`}</h2>
    <h3 {...{
      "id": "overview"
    }}>{`Overview`}</h3>
    <p>{`Many businesses create reports on project progress or the status of certain accounts for clients or stakeholders. This process is cumbersome and often uses data already in the company's customer relationship management (CRM) system. Automating report generation gives teams time back and ensures reports are as up-to-date as possible`}</p>
    <p>{`Adobe Acrobat Services allows businesses to:`}</p>
    <ul>
      <li parentName="ul">{`Create report templates for various purposes`}</li>
      <li parentName="ul">{`Automatically merge data from business systems (e.g. CRM)`}</li>
      <li parentName="ul">{`Limit edits by protecting the resulting PDF file`}</li>
    </ul>
    <h3 {...{
      "id": "relevant-apis"
    }}>{`Relevant APIs`}</h3>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/document-services/src/pages/apis/pdf-services.md"
        }}>{`Adobe PDF Services API`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/document-services/src/pages/apis/doc-generation.md"
        }}>{`Adobe Document Generation API`}</a></li>
    </ul>
    <h3 {...{
      "id": "scenario"
    }}>{`Scenario`}</h3>
    <p>{`A sales organization repeatedly needs to create reports on the status of a sales account with data stored in their CRM system. This data is then shared with internal stakeholders or the client directly and data requests sometimes happen spontaneously. To ensure that the team always has the required materials, managers in the organization need to quickly generate reports that include the latest accurate data.`}</p>
    <h3 {...{
      "id": "building-this-solution"
    }}>{`Building this Solution`}</h3>
    <ol>
      <li parentName="ol">{`Create a simple data capture form using Microsoft Form (or another form builder)`}</li>
      <li parentName="ol">{`Design the report template using Microsoft Word`}</li>
      <li parentName="ol">{`Use Adobe Document Generation Tagger in Word to place fields into the template based on the data model from the form`}</li>
      <li parentName="ol">{`Run the Adobe Document Generation API to merge data from the form into the template, creating a final report in PDF`}</li>
      <li parentName="ol">{`Use Adobe PDF Services API to protect the document from editing`}</li>
    </ol>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      